import { Component } from 'react';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
export class GlobalErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {};
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  componentDidCatch(error, info) {
    Raven.captureException(error, {
      extra: {
        componentStack: info.componentStack
      }
    });
  }
  render() {
    if (this.state.error) {
      return /*#__PURE__*/_jsx(this.props.ErrorComponent, {
        error: this.state.error
      });
    }
    return this.props.children;
  }
}